<template>
  <div>
    <loading v-if="!showContent"></loading>
    <div class="row" v-if="showContent">
      <div class="program-details">
        <div class="col col-md-12"><h1 class="titulo">{{ item.nameProgram }}</h1></div>
        <div class="col col-md-3" v-if="item.imageLocutor">
          <img v-if="item.imageLocutor" :src="item.imageLocutor"/>
          <img v-if="!item.imageLocutor" src="dist/images/sem_imagem.jpg"/>
        </div>
        <div class="col col-md-9">
          <p>{{ item.descriptionProgram }}</p>
          Com
          <router-link :to="'/locutor/'+item.idLocutor">
            {{ item.nameLocutor }}
          </router-link>
          <table v-for="content in programs">
            <tr v-for="item in content">
              <td>
                {{ item.init.substr(0,5) }} - {{ item.finish.substr(0,5) }}
              </td>
              <td style="width: 50%">
                {{ getStringDay(item.day) }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';

  export default {
    components: {
      Loading
    },
    data() {
      return {
        title: 'Programa',
        showContent: false,
        programs: [],
        daysList: [],
        stringDays: [
          {
            value: 'SEG',
            label: 'Segunda',
            order: 1
          },
          {
            value: 'TER',
            label: 'Terça',
            order: 2
          },
          {
            value: 'QUA',
            label: 'Quarta',
            order: 3
          },
          {
            value: 'QUI',
            label: 'Quinta',
            order: 4
          },
          {
            value: 'SEX',
            label: 'Sexta',
            order: 5
          },
          {
            value: 'SAB',
            label: 'Sábado',
            order: 6
          },
          {
            value: 'DOM',
            label: 'Domingo',
            order: 0
          }
        ]
      }
    },
    activated() {
      this.initialize()
    },
    created() {
      this.initialize()
    },
    methods: {
      initialize(){
        let self = this;
        self.showContent = false;
        self.programs = [];
        get('program-details/' + this.$route.params.id).then(function (response) {
          self.item = response.data.result.data;
          self.programs = response.data.result.data.programs
          self.showContent = true;
        });
      },
      getStringDay(day) {
        let stringDays = [
          {
            value: 'SEG',
            label: 'Segunda'
          },
          {
            value: 'TER',
            label: 'Terça'
          },
          {
            value: 'QUA',
            label: 'Quarta'
          },
          {
            value: 'QUI',
            label: 'Quinta'
          },
          {
            value: 'SEX',
            label: 'Sexta'
          },
          {
            value: 'SAB',
            label: 'Sábado'
          },
          {
            value: 'DOM',
            label: 'Domingo'
          }
        ];
        let stringDay = '';
        stringDays.forEach(function (value) {
          if (value.value === day) {
            stringDay = value.label;
          }
        });
        return stringDay;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/ProgramDetails.vue